module.exports = __webpack_public_path__ + "img/user-terminated.f4e49422.svg";